import { Route, Routes } from 'react-router-dom';
import { JobDetailsPage } from '../../../jobs/components/JobDetailsPage/JobDetailsPage';
import { PipelineJobsView } from '../../../jobs/components/JobsView/PipelineJobsView/PipelineJobsView';
import { Integration } from '../../../shared/interfaces/integration';

export function PipelineOverviewJobHistory({ integration }: { integration: Integration }) {
  return (
    <Routes>
      <Route path='/:jobId' element={<JobDetailsPage />} />

      <Route path='/' element={<PipelineJobsView integration={integration} />} />
    </Routes>
  );
}
